// extracted by mini-css-extract-plugin
export default {"label":"p46AI","flex":"vrukO"};